import { HttpErrorResponse } from '@angular/common/http';
import { apiErrorSchema } from '@killer-party/contracts';

const NETWORK_MESSAGE = 'Le QG ne répond pas. Vérifiez votre réseau puis réessayez.';
const UNAUTHORIZED_MESSAGE = "Votre accès à cette mission n'est plus valide.";
const GENERIC_MESSAGE = 'Une erreur inattendue est survenue. Réessayez.';

// Message a afficher pour une erreur d'appel a l'API. Les erreurs metier de
// l'API ({ code, message }) sont deja redigees pour l'utilisateur.
export function apiErrorMessage(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) {
    return GENERIC_MESSAGE;
  }
  if (error.status === 0) {
    return NETWORK_MESSAGE;
  }
  const body = apiErrorSchema.safeParse(error.error);
  if (body.success) {
    return body.data.message;
  }
  return error.status === 401 ? UNAUTHORIZED_MESSAGE : GENERIC_MESSAGE;
}

// Code metier d'une erreur d'API ({ code, message }), null sinon.
export function apiErrorCode(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }
  const body = apiErrorSchema.safeParse(error.error);
  return body.success ? body.data.code : null;
}

// Statut HTTP d'une erreur d'appel a l'API, null sinon.
export function apiErrorStatus(error: unknown): number | null {
  return error instanceof HttpErrorResponse ? error.status : null;
}
